module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZbPRXO/tc-custom/9781488061325.jpg?1743821179123",
      "alt": "This image is the cover for the book Under Suspicion"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Under Suspicion\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("With an enemy who’s closer than they think…"), _c('br'), _c('br'), _vm._v("following the truth could pull them in too deep."), _c('br'), _c('br')]), _vm._v("Hired to help the navy SEALs train their working dolphins, veterinarian Keilani Lucas inadvertently crosses a vicious drug-smuggling ring on her first day. And when her fellow trainer, Lieutenant Micah Kent, comes to her rescue, she suddenly has an around-the-clock bodyguard. But with a traitor on the inside, can Keilani and Micah expose the mole before it’s too late?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sommer Smith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sommer Smith teaches littles in a rural school district when she isn't writing. She loves reading romances and writing about fairy tales, animals, and going to the beach. She started writing her first novel when she was thirteen and has wanted to write romances since. Her three children and her amazing granddaughter provide her inspiration to write with their many antics. With two dogs and a horse to keep her active in between, Sommer stays busy traveling to visit the kids in colleges in two states."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0